//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment-timezone'
import { mapGetters, mapState } from 'vuex'

import { markdownToHTML } from '@/lib/converters'
import { formatDate, getBrowserTimezone } from '@/lib/utils'

import announcements from '@/graphql/queries/announcements/announcements.gql'
import proxies from '@/graphql/queries/accounts/proxies.gql'

/**
 * Notifications that need to be displayed at the top of every logged in page.
 * This includes prominent subscription notifications, account issues, and
 * other important messages.
 */
export default {
  name: 'GlobalNotifications',
  data() {
    return {
      proxies: [],
      announcements: []
    }
  },
  apollo: {
    announcements: {
      query: announcements,
      skip() {
        return !this.isLoggedIn
      }
    },
    proxies: {
      query: proxies,
      pollInterval: 1000 * 60 * 60, // 1 hour
      skip() {
        return !this.isLoggedIn
      }
    }
  },
  computed: {
    ...mapState(['profile']),
    ...mapGetters(['isLoggedIn', 'hasPendingEmailConfirmation']),
    shouldShowTimezoneBanner() {
      if (this.profile && this.profile.timezone) {
        try {
          const profileTzOffset = moment().tz(this.profile.timezone).utcOffset()
          const browserTzOffset = moment().tz(getBrowserTimezone()).utcOffset()
          return (
            profileTzOffset !== browserTzOffset &&
            this.$prefs.showTimezoneBanner
          )
        } catch (e) {
          return false
        }
      }
    },
    prominentAnnouncements() {
      return this.announcements.filter((a) => a.prominent)
    },
    disconnectedAccounts() {
      if (!this.profile) {
        return []
      } else {
        return this.profile.socialAccounts.filter(
          (account) => !account.isConnected
        )
      }
    },
    accountPastDue() {
      return (
        this.profile &&
        this.profile.account.subscriptionStatus.toLowerCase() === 'past_due'
      )
    },
    shouldShowPostponeUpdate() {
      return this.isLoggedIn && this.$store.state.postponeHasUpdate
    },
    proxiesWithIssues() {
      return this.proxies.filter((proxy) => proxy.failedAttempts >= 3)
    }
  },
  methods: {
    formatDate,
    markdownToHTML,
    announcementType(announcement) {
      if (announcement.announcementType) {
        return announcement.announcementType.toLowerCase().replace('_', '-')
      } else {
        return 'is-light'
      }
    },
    refreshPage() {
      window.location.reload()
      return false
    }
  }
}
